module.exports = __webpack_public_path__ + "static/visual-noise-dont-5cd67822a47c11f9e05564309d199422.png";